import $ from 'jquery';

$(function () {

  $(".team .menu-btn").on('click', function() {

    // Get department name
    const department = $(this).text();

    console.log(department);

    // Change menu button active state
    $(".menu-btn").removeClass("active");
    $(this).addClass('active');

    $('.js-people-grid').fadeOut(300, function() {

        if (department === 'Everyone') {
            $('.card-profile').show();
        } else {
            $('.card-profile').hide();
            $(`.card-profile[data-department*="${department}"]`).show();
        }

        $('.js-people-grid').fadeIn();
    });

  });

});